import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { mensajeError } from '../util';

export function Login() {
  const { usuario, cargando, iniciarSesion, iniciarConCorreo } = useAuth();
  const [error, setError] = useState('');
  const [entrando, setEntrando] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // Permite entrar solo con el alias (ej. "juridico1"): se completa el dominio.
  const correoCompleto = (v: string) =>
    v.includes('@') ? v.trim() : `${v.trim()}@centrojuridicointernacional.com`;

  if (!cargando && usuario) return <Navigate to="/" replace />;

  async function ejecutar(fn: () => Promise<void>) {
    setError('');
    setEntrando(true);
    try {
      await fn();
    } catch (e) {
      setError(mensajeError(e));
    } finally {
      setEntrando(false);
    }
  }

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="logo" aria-hidden>🌐</div>
        <h1 style={{ color: 'var(--verde-800)' }}>Trazabilidad de Carpetas</h1>
        <p className="subtitulo">Centro Jurídico Internacional</p>
        {error && <div className="aviso error">{error}</div>}

        <form onSubmit={(e) => { e.preventDefault(); void ejecutar(() => iniciarConCorreo(correoCompleto(email), password)); }}>
          <div className="campo" style={{ textAlign: 'left' }}>
            <label>Usuario o correo</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="juridico1  (o su correo completo)" autoCapitalize="none" />
          </div>
          <div className="campo" style={{ textAlign: 'left' }}>
            <label>Contraseña</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          <button className="btn btn-primario" style={{ width: '100%' }} disabled={entrando}>
            {entrando ? 'Ingresando…' : 'Ingresar'}
          </button>
        </form>

        <div style={{ margin: '16px 0', color: 'var(--texto-suave)', fontSize: 13 }}>— o —</div>
        <button className="btn btn-secundario" style={{ width: '100%' }} disabled={entrando}
          onClick={() => void ejecutar(iniciarSesion)}>
          Ingresar con Google Workspace
        </button>

        <p className="subtitulo" style={{ marginTop: 18, fontSize: 12 }}>
          Use su correo corporativo @centrojuridicointernacional.com
        </p>
      </div>
    </div>
  );
}
